"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.csButtonContentPadding = void 0;
exports.csButtonContentPadding = {
    paddingLeft: 5,
};
//# sourceMappingURL=CsButton.styles.js.map